import { render, staticRenderFns } from "./form_detail_happiness_tips_component.vue?vue&type=template&id=4a48d8ca&scoped=true"
import script from "./form_detail_happiness_tips_component.vue?vue&type=script&lang=js"
export * from "./form_detail_happiness_tips_component.vue?vue&type=script&lang=js"
import style0 from "./form_detail_happiness_tips_component.vue?vue&type=style&index=0&id=4a48d8ca&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a48d8ca",
  null
  
)

export default component.exports